import React from "react";
import ConferencesList from "../../Conferences/ConferencesList";

const Conferences = () => {
  return (
    <>
      <div className={"mb-2"}>
        <ConferencesList />
      </div>
    </>
  );
};

export default Conferences;
